import { CampaignStepActivateData } from 'modules/campaigns/campaign-steps/types/campaign-step-interface'
import { CampaignStepViewInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-view-interface'
import {
  AttachmentFileInterface,
  UnsavedAttachmentFileInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'
import { TempStateType } from 'shared/components/dashboard-mail-editor/types/temp-state-type'
import { isAttachmentInterface } from 'shared/components/dashboard-mail-editor/utils/is-attachment-interface'
import { convertTimeValueToSeconds } from 'shared/components/date-picker/time-delay-picker/utils'

export const transformToCampaignStepData = ({
  tempState,
  activateData,
  attachmentsTempState,
  campaignStepData,
}: {
  tempState?: TempStateType
  activateData: CampaignStepActivateData | null
  attachmentsTempState?: Array<AttachmentFileInterface | UnsavedAttachmentFileInterface>
  campaignStepData: CampaignStepViewInterface
}): CampaignStepViewInterface => {
  return {
    ...campaignStepData,
    mailing: {
      ...campaignStepData.mailing,
      currentEmail: {
        ...campaignStepData.mailing.currentEmail,
        ...tempState,
        attachments: attachmentsTempState?.filter(isAttachmentInterface) ?? [],
      },
    },
    delayFromPreviousStep: activateData
      ? convertTimeValueToSeconds(activateData.delayValue, activateData.delayUnit)
      : null,
    timeOfTheDay: activateData?.timeOfTheDay ?? null,
    excludedWeekdays: activateData?.excludedWeekdays ?? [],
    stepBefore:
      activateData?.stepBefore && campaignStepData.stepBefore
        ? {
            id: activateData.stepBefore,
            mailing: campaignStepData.stepBefore.mailing,
          }
        : null,
  }
}
